/**
 * Force a cursor across the whole document for the duration of a pointer drag,
 * and suppress text selection. Pass null to restore. Without this the cursor
 * reverts to the default/selection cursor as the pointer leaves the handle.
 */
export function setGlobalCursor(cursor: string | null): void {
  document.body.style.cursor = cursor ?? '';
  document.body.style.userSelect = cursor ? 'none' : '';
}
